// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/orgcharts",
  ListEmployee:
    "/pyr/companies/{OrgId}/orgcharts/dept/{departmentId}/employees",
};
